import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';
import portraitImage from '../assets/images/IMG_2941.jpg';

export default function About() {
    return (
        <div className="aboutSection" id="about">
            <div className="aboutContainer">
                <div className="aboutTitling">
                    <p className="aboutTitle">ABOUT ME</p>
                </div>
                <div className="grids">
                    <div className="about">
                        <div className="aboutText">
                            <br/>
                            <p className="aboutTextContent">
                                I am a recent graduate from California State University, Fullerton with Bachelors and Masters degrees in Computer Science and Computer Engineering respectively. Hailing the San Francisco Bay Area, I am currently working as a Software Developer on multiple Full-Stack projects.  My development journey started in Spring 2021 when I became Webmaster of my schools Theta Tau chapter. From then on, I have been deeply enthrawled with web and mobile development but have vastly expanded my skills and interests.
                            </p>
                            <br/>
                            <p className="aboutTextContent">
                                Learning is something I truly enjoy and hope to continue doing into the forseeable future. From mobile apps to web apps to firmware engineering to digital system deisgn, my portfolio is and will always continue to grow as I learn and develop my skills.
                            </p>
                            <br/>
                        </div>
                    </div>
                    <div className="portraitContainer">
                        <div className="portrait">
                            <div id="portraitImg" href="#"><img src={portraitImage} alt="Portrait of Spencer DeMera (5-2-2025)"></img></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
